<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-xs-9">
        <h2>Mailbox</h2>
        <ol class="breadcrumb">
          <li>
            You will recieve message only from SALL.
          </li>
        </ol>
      </div>
      <!-- <template v-if="isAdmin">
        <div class="col-xs-3 mobile-hide" id="compose_mail">
          <button class="btn btn-primary pull-right" data-toggle="modal" data-target="#mailComposeModal">
            <strong>Compose Mail</strong>
          </button>
          <div class="modal inmodal fade" id="mailComposeModal" tabindex="-1" role="dialog" aria-labelledby="mailComposeLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Compose Mail</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form class="form-horizontal" method="get">
                    <div class="form-group">
                      <label class="col-sm-2 control-label">To:</label>
                      <div class="col-sm-10">
                        <input type="text" class="form-control" value="" v-model="postUserMailTo">
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label">Subject:</label>
                      <div class="col-sm-10">
                        <input type="text" class="form-control" value="" v-model="postUserMailSubject">
                      </div>
                    </div>
                    <div class="mail-text h-200">
                      <quill-editor ref="myQuillEditor" v-model="postUserMailContent" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)">
                      </quill-editor>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                  <button type="submit" class="btn btn-md btn-primary" data-dismiss="modal" v-on:click="SendingMail()">Send</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-3 mobile-show" id="compose_mail_mobile">
          <button class="btn btn-xs btn-primary margin-top-20-px pull-right" data-toggle="modal" data-target="#mailComposeModal-mobile">
            <strong>Compose Mail</strong>
          </button>
          <div class="modal inmodal fade" id="mailComposeModal-mobile" tabindex="-1" role="dialog" aria-labelledby="mailComposeLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Compose Mail</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form class="form-horizontal" method="get">
                    <div class="form-group">
                      <label class="col-sm-2 control-label">To:</label>
                      <div class="col-sm-10">
                        <input type="text" class="form-control" value="" v-model="postUserMailTo">
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 control-label">Subject:</label>
                      <div class="col-sm-10">
                        <input type="text" class="form-control" value="" v-model="postUserMailSubject">
                      </div>
                    </div>
                    <div class="mail-text h-200">
                      <quill-editor ref="myQuillEditor" v-model="postUserMailContent" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)">
                      </quill-editor>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                  <button type="submit" class="btn btn-md btn-primary" data-dismiss="modal" v-on:click="SendingMail()">Send</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template> -->
    </div>
    <div class="row wrapper wrapper-content">
      <div class="col-lg-12 animated fadeInRight">
        <div class="mail-box-header">
          <h2>
            Inbox ({{ messages.length }})
          </h2>
          <div class="mail-tools tooltip-demo m-t-md">
            <button
                    class="btn btn-white btn-sm"
                    data-toggle="tooltip"
                    data-placement="left"
                    title="Select All"
                    @click="selectAll">
              <i class="fa fa-check" /> Select All
            </button>
            <button
                    class="btn btn-white btn-sm"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Mark as read"
                    @click="markAsRead">
              <i class="fa fa-eye" />
            </button>
          </div>
        </div>
        <div class="mail-box">
          <table class="table table-hover table-mail">
            <thead>
              <tr>
                <td />
                <td class="mail-subject">
                  <span>Name</span>
                </td>
                <td class="mail-date text-right"><span>Time</span></td>
              </tr>
            </thead>
            <tbody>
              <tr
                  v-for="message in messages"
                  :key="message.id"
                  :class="{'unread': !message.status, 'read': message.status}">
                <td
                    class="check-mail"
                    for="">
                  <input
                         :value="message"
                         v-model="selectedMessages"
                         type="checkbox"
                         class="i-checks">
                </td>
                <td
                    class="mail-subject"
                    @click="openMessage(message.id); message.status = true;">
                  <span>{{ message.subject }}</span>
                </td>
                <td class="text-right mail-date"><span>{{ message.time_string | moment("YYYY-MM-DD HH:mm:ss") }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
         id="mailDetailModal"
         class="modal inmodal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="mailDetailLabel"
         aria-hidden="true">
      <div
           class="modal-dialog"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Mail Detail</h5>
            <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form
                  class="form-horizontal"
                  method="get">
              <div class="form-group">
                <label class="col-sm-2 control-label">Subject:</label>
                <label class="col-sm-10">
                  {{ openedMessage.subject }}
                </label>
              </div>
              <div
                   class="mail-text h-200 p-t-md"
                   height="100%">
                <iframe
                        :srcdoc="openedMessage.content"
                        width="100%"
                        height="600px"
                        frameborder="0" />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    data-dismiss="modal">
              OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";

export default {
  name: "Mailbox",
  components: {
    quillEditor
  },
  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      content: null,
      messages: [],
      openedMessage: {
        subject: "",
        content: ""
      },
      selectedMessages: []
    };
  },
  computed: {
    isAdmin () {
      if (this.user.roles) {
        const len = this.user.roles.length;
        for (let j = 0; j < len; j += 1) {
          if (this.user.roles[j] === "Admin") {
            return true;
          }
        }
      }
      return false;
    },
    getUserMailUrl () {
      return `user/${this.user.id}/message`;
    }
  },
  mounted () {
    this.fetchMessage();
  },
  methods: {
    // onEditorBlur() {
    //   // 失去焦点事件
    // },
    // onEditorFocus() {
    //   // 获得焦点事件
    // },
    // onEditorChange() {
    //   // 内容改变事件
    // },
    // SendingMail() {
    //   // eslint-disable-next-line
    //   var $this = this;
    //   // eslint-disable-next-line
    //   var dateTime = new Date();
    //   this.postUserMailFrom = this.user.name;
    //   this.postUserMailTime = dateTime.toLocaleString();
    //   this.request
    //     .post("/mail", {
    //       from: $this.postUserMailFrom,
    //       to: $this.postUserMailTo,
    //       subject: $this.postUserMailSubject,
    //       content: $this.postUserMailContent,
    //       time: $this.postUserMailTime
    //     })
    //     .then(response => {
    //       window.alert(response);
    //       // eslint-disable-next-line
    //     })
    //     .catch(function(error) {
    //       window.alert(error);
    //     });
    // },
    // MarkAsRead() {}
    openMessage (id) {
      const that = this;
      this.$emit("showLoading");
      this.request
        .get(`message/${id}`)
        .then(response => {
          that.openedMessage.content = response.data.content;
          that.openedMessage.subject = response.data.msg.subject;
          that.$emit("hideLoading");
          this.errorShow = false
          this.errorMessage = ""
          $("#mailDetailModal").modal("show");
          that.$emit("refreshUser");
        })
        .catch(error => {
          toastr.error(error.response.data.message);
          that.$emit("hideLoading");
        });
    },
    fetchMessage () {
      var that = this;
      this.$emit("showLoading");
      this.request
        .get(this.getUserMailUrl)
        .then(response => {
          that.messages = response.data.messages;
          that.transformMail();
        })
        .catch(error => {
          toastr.error(error.response.data.message);
        })
        .finally(() => {
          console.log(that.messages);
          that.$emit("hideLoading");
        });
    },
    transformMail () {
      this.messages.forEach(mail => {
        if (mail.time) {
          mail.time_string = mail.time.toISOStringZoned();
        } else {
          let e;
          e = new Date();
          mail.time_string = e.toISOStringZoned();
        }
      });
    },
    selectAll () {
      const previousLength = this.selectedMessages.length;
      this.selectedMessages = new Array();
      if (previousLength !== this.messages.length) {
        this.messages.forEach(message => this.selectedMessages.push(message));
      }
    },
    markAsRead () {
      const that = this;
      const total = this.selectedMessages.length;
      const count = 0;
      this.selectedMessages.forEach(message => {
        that.request
          .get(`message/${message.id}/markasread`)
          .then(response => {
            message.status = true;

            count += 1;
            if (count === total) that.$emit("refreshUser");
          })
          .catch(error => {
            toastr.error(error.response.data.message);
          });
      });
    }
  }
};
</script>


<style>
</style>
